<template>
    <header class="page-header">
        <div class="container">
            <router-link to="/" class="logo">
                <img src="../assets/svg/logo.svg" alt="airBaltic">
            </router-link>

            <ul class="language-nav">
                <li :class="{'is-active': activeLanguage === 'lv'}">
                    <a href="javascript:;" hreflang="lv" @click="switchLanguage('lv')">
                        LV
                    </a>
                </li>
                <li :class="{'is-active': activeLanguage === 'ru'}">
                    <a href="javascript:;" hreflang="ru" @click="switchLanguage('ru')">
                        RU
                    </a>
                </li>
                <li :class="{'is-active': activeLanguage === 'en'}">
                    <a href="javascript:;" hreflang="en" @click="switchLanguage('en')">
                        EN
                    </a>
                </li>
            </ul>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'PageHeader',

        created() {
            if (!localStorage.getItem('locale')) {
                localStorage.setItem('locale', 'en')
            }
        },

        computed: {
            activeLanguage() {
                if (localStorage.getItem('locale')) {
                    return localStorage.getItem('locale')
                }

                return 'en';
            }
        },

        methods: {
            async switchLanguage(language) {
                localStorage.setItem('locale', language);

                await this.$api.switchTranslations(language);

                window.location.reload();
            }
        }
    }
</script>